import React from 'react';
import { motion } from 'framer-motion';
import { PhoneCall, ClipboardList, CheckCircle2 } from 'lucide-react';
const steps = [{
  icon: PhoneCall,
  title: 'Консультація',
  description: 'До 5 хвилин. Вислуховуємо ваш запит та визначаємо перспективи справи.'
}, {
  icon: ClipboardList,
  title: 'Алгоритм',
  description: 'Розповідаємо чіткий покроковий план дій, узгоджуємо деталі та вартість.'
}, {
  icon: CheckCircle2,
  title: 'Вирішення',
  description: 'Беремо всю юридичну роботу на себе та доводимо справу до результату.'
}];
export function Process() {
  return <section className="py-24 bg-slate-50 rounded-[3rem] mx-4 lg:mx-8 mb-24" data-id="element-84">
      <div className="max-w-7xl mx-auto px-6" data-id="element-85">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-86">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 tracking-tight" data-id="element-87">
            Як ми працюємо
          </h2>
          <p className="text-slate-500 text-lg" data-id="element-88">
            Прозорий та зрозумілий процес. Цінуємо ваш час.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-89">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-10 left-[15%] right-[15%] h-px bg-slate-200" data-id="element-90" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="relative flex flex-col items-center text-center" data-id="element-91">
              <div className="w-20 h-20 rounded-full bg-white border-4 border-slate-50 shadow-sm flex items-center justify-center mb-6 relative z-10" data-id="element-92">
                <step.icon className="w-8 h-8 text-slate-700 stroke-[1.5]" data-id="element-93" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-94">
                {step.title}
              </h3>
              <p className="text-slate-500 leading-relaxed text-sm max-w-[250px]" data-id="element-95">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}